import { getSavedUtm } from "../services/utmHelpers";

export const postBackCPAExchange = (trackID)=>{
  // Get utm_content from URL
    const utm = getSavedUtm();
    const clickId = utm?.utm_content || null;
  if (!clickId) {
      console.warn('utm_content not found in URL');
      return;
  }

  // Send POST request to PHP
  fetch('/api/postbackCPAExchangePayPal.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: `click_id=${encodeURIComponent(clickId)}&track_id=${encodeURIComponent(trackID)}`
  })
  .then(r => r.json())
  .then(data => {
      console.log('Server response:', data);
  })
  .catch(err => {
      console.error('Error sending request:', err);
  });
}